import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import TikTokIcon from "@/components/TikTokIcon";
import logoImg from "@/assets/logo.png";

const Footer = () => (
  <footer className="border-t border-border/50 relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-t from-background via-card/50 to-transparent pointer-events-none" />
    <div className="container mx-auto px-4 py-12 sm:py-16 relative">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex flex-col items-center sm:items-start gap-3">
          <img src={logoImg} alt="Encore Republic" width={140} height={28} className="h-7 object-contain opacity-70" />
          <p className="text-sm text-muted-foreground text-center sm:text-left">
            Share your concert memories with the world.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Tooltip>
            <TooltipTrigger asChild>
              <a href="https://tiktok.com/@encorerepublic" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="p-2.5 rounded-full bg-secondary/50 text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all">
                <TikTokIcon size={24} />
              </a>
            </TooltipTrigger>
            <TooltipContent>TikTok</TooltipContent>
          </Tooltip>
        </div>
      </div>
      <div className="mt-8 pt-6 border-t border-border/30 flex items-center justify-center sm:justify-end gap-4">
        <div className="flex items-center gap-4">
          <a href="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors">
            Terms of Service
          </a>
          <a href="/privacy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
            Privacy Policy
          </a>
          <a href="/copyright" className="text-xs text-muted-foreground hover:text-primary transition-colors">
            Copyright Policy
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
